import { InputWrapper } from '@vrplatform/components';
import { SegmentedControl, type SegmentedControlItem } from '@mantine/core';
import type { party_enum } from '@vrplatform/graphql';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useFeeForm } from '../useFeeForm';

type Props = {
  type: 'credit' | 'debit';
};

export const FeeAccountPartyEditor = ({ type }: Props) => {
  const methods = useFeeForm();

  const options = useMemo<SegmentedControlItem[]>(
    () => [
      { label: 'Owners', value: 'owners' satisfies party_enum },
      { label: 'Manager', value: 'manager' satisfies party_enum },
    ],
    []
  );

  return (
    <Controller
      control={methods.control}
      name={type === 'credit' ? 'creditParty' : 'debitParty'}
      rules={{
        required:
          type === 'credit'
            ? 'Credit Party is required'
            : 'Debit Party is required',
      }}
      render={({ field, fieldState }) => {
        return (
          <InputWrapper error={fieldState.error?.message}>
            <SegmentedControl
              fullWidth
              data={options}
              size="xs"
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={field.disabled}
              styles={(theme) => ({
                label: {
                  fontSize: theme.fontSizes.sm,
                },
              })}
            />
          </InputWrapper>
        );
      }}
    />
  );
};
